import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-delete-container',
    templateUrl: './delete-container.component.html',
    styleUrls: ['./delete-container.component.scss', '../../../../../../Common/TargetingShared/components/ResultCard/result-card.scss'],
    standalone: false
})
export class DeleteContainerComponent {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() key: string;
    @Output() removeParam = new EventEmitter<string>();
}
